import { Grid, Typography } from "@mui/material";
import { styled as styling } from "@mui/material/styles";

export const GridContainerStyled = styling(Grid)((props) => ({
  display: "flex",
  padding: "80px 120px",
  flexDirection: "column",
  alignItems: "center",
  gap: "10px",

  [props.theme.breakpoints.down("lg")]: {
    padding: "40px 24px",
  },

  [props.theme.breakpoints.down("tablet")]: {
    padding: "40px 16px",
  },
}));

export const CardListContainer = styling(Grid)((props) => ({
  display: "flex",
  width: "100%",
  maxWidth: "1200px",
  justifyContent: "space-between",
  alignItems: "center",

  [props.theme.breakpoints.down("lg")]: {
    maxWidth: "720px",
    flexDirection: "column-reverse",
    alignItems: "center",
    gap: "24px",
    alignSelf: "stretch",
    margin: "auto",
    textAlign: "center",
  },

  [props.theme.breakpoints.down("tablet")]: {
    textAlign: "left",
  },
}));

export const CardImage = styling("img")((props) => ({
  height: "100%",
  width: "100%",
  flexShrink: "0",
  borderRadius: "8px",
  maxHeight: "260px",
  maxWidth: "500px",
  objectFit: "cover",

  [props.theme.breakpoints.down("lg")]: {
    maxHeight: "260px",
    maxWidth: "500px",
  },

  [props.theme.breakpoints.down("tablet")]: {
    maxHeight: "170px",
    maxWidth: "330px",
  },
}));

export const CardTextContainer = styling(Grid)((props) => ({
  display: "flex",
  alignItems: "flex-start",
  flexDirection: "column",
  gap: "24px",
  maxWidth: "438px",

  [props.theme.breakpoints.down("lg")]: {
    maxWidth: "720px",
  },

  [props.theme.breakpoints.down("tablet")]: {},
}));

export const CardText = styling(Typography)((props) => ({
  color: "#261754",
  fontFamily: props.type == "desc" ? "Inter" : "Georgia",
  fontSize: props.type == "desc" ? "20px" : "40px",
  fontStyle: "normal",
  fontWeight: 400,
  lineHeight: props.type == "desc" ? "30px" : "48px",
  alignSelf: "stretch",
  letterSpacing: props.type == "desc" ? "0.03px" : "0.06px",

  [props.theme.breakpoints.down("lg")]: {
    textAlign: props.type == "desc" ? "center" : "center",
    fontSize: props.type == "desc" ? "20px" : "36px",
    lineHeight: props.type == "desc" ? "30px" : "43.2px",
    letterSpacing: props.type == "desc" ? "0.03px" : "0.36px",
  },

  [props.theme.breakpoints.down("tablet")]: {
    fontSize: props.type == "desc" ? "16px" : "24px",
    lineHeight: props.type == "desc" ? "22.4px" : "28.8px",
    textAlign: props.type == "desc" ? "left" : "left",
    letterSpacing: props.type == "desc" ? "unset" : "0.036px",
  },
}));
